const Request = require('./BaseRequest')
const StatsGraph = require('../graph/StatsGraph')

module.exports = class StatsRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new StatsGraph(this.apiDomain)
    }
  
    IQPoints(contact_id)
    {
        let args = {contact_id: contact_id, type: "iq_points"}
        let { type, query} = this.graph.IQPointsQuery([
            'points'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }


    badgesEarned(contact_id)
    {
        let args = {contact_id: contact_id, type: "badges_earned"}
        let { type, query} = this.graph.badgesEarnedQuery([
            'points'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    reviewsGiven(contact_id)
    {
        let args = {contact_id: contact_id, type: "reviews_given"}
        let { type, query} = this.graph.reviewsGivenQuery([
            'points'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    articlesRead(contact_id)
    {
        let args = {contact_id: contact_id, type: "article_reads"}
        let { type, query} = this.graph.articlesReadQuery([
            'points'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    videoWatch(contact_id)
    {
        let args = {contact_id: contact_id, type: "video_watched"}
        let { type, query} = this.graph.videoWatchQuery([
            'points'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    audioListened(contact_id)
    {
        let args = {contact_id: contact_id, type: "audio_listened"}
        let { type, query} = this.graph.audioListenedQuery([
            'points'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    filesDownloaded(contact_id)
    {
        let args = {contact_id: contact_id, type: "files_downloaded"}
        let { type, query} = this.graph.filesDownloadedQuery([
            'points'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    recipeUsed(contact_id)
    {
        let args = {contact_id: contact_id, type: "recipe_used"}
        let { type, query} = this.graph.recipeUsedQuery([
            'points'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    newPointThisMonth(contact_id)
    {
        let args = {contact_id: contact_id, type: "new_points_this_month"}
        let { type, query} = this.graph.newPointThisMonthQuery([
            'points'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    newPointThisYear(contact_id)
    {
        let args = {contact_id: contact_id, type: "new_points_this_year"}
        let { type, query} = this.graph.newPointThisYearQuery([
            'points'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    averagePointsPerMonth(contact_id)
    {
        let args = {contact_id: contact_id, type: "average_points_per_month"}
        let { type, query} = this.graph.averagePointsPerMonthQuery([
            'points'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }


    monthlyStats(contact_id,year)
    {
        let args = {contact_id: contact_id, year: year}
        let { type, query} = this.graph.monthlyStatsQuery([
            'stats'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    contentViewed(contact_id)
    {
        let args = {contact_id: contact_id}
        let { type, query} = this.graph.contentViewedQuery([
            'content'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }
}   